export { PasteClipboardDataToStageEntryPoint } from './pasteClipboardDataToStageEntryPoint';
